import { api, API } from "@/lib/auth";

export { api, API };

export const fetchCatalog = async () => (await api.get("/catalog")).data;
export const previewQuote = async (config) => (await api.post("/quotes/preview", config)).data;
export const createQuote = async (payload) => (await api.post("/quotes", payload)).data;
export const saveQuoteDraft = async (payload) => (await api.post("/quotes/drafts", payload)).data;
export const listQuotes = async () => (await api.get("/quotes")).data;
export const getQuote = async (id) => (await api.get(`/quotes/${id}`)).data;
export const deleteQuote = async (id) => (await api.delete(`/quotes/${id}`)).data;
export const updateQuoteQuantity = async (id, quantity) => (await api.patch(`/quotes/${id}/quantity`, { quantity })).data;
export const createColorRequest = async (payload) => (await api.post("/color-request", payload)).data;
export const estimateDelivery = async (postalCode) => (await api.get(`/delivery/estimate`, { params: { postal_code: postalCode } })).data;
export const analyzeSlopeImage = async (payload) => (await api.post("/configurator/analyze-slope-image", payload)).data;

export const formatEuro = (n) =>
  new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR" }).format(n);
